<template>
    <!-- Основной контейнер для всех страниц -->
    <MainLayout>
        <!-- Управление балансом -->
        <DropBalanceSettings 
        :drop-user-id="dropUserId"
        />

        <!-- Блок сортировки заказов -->
        <SortComponent @filters-change="handleFiltersChange" :admin_sort="true"/>

        <!-- Блок отображения заказов конкретного дропа -->
        <OrdersComponent 
            ref="ordersList"
            :filters="activeFilters" 
            :admin_orders="true"
            :drop_user_id="dropUserId"
            @order-updated="handleOrderUpdated"
        />

    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue';
import SortComponent from '@/components/SortComponent.vue';
import OrdersComponent from '@/components/DropOrdersCardComponent.vue';
import DropBalanceSettings from '@/components/DropBalanceSettings.vue';

export default {
    components: {
        MainLayout,
        OrdersComponent,
        SortComponent,
        DropBalanceSettings,
    },
    data() {
        return {
            activeFilters: {},
            dropUserId: null,
        }
    },
    mounted() {
        // Получаем ID дропа из параметров маршрута
        this.dropUserId = this.$route.params.dropId || this.$route.query.dropId;
        console.log('Полученный dropUserId:', this.dropUserId);
        
        if (!this.dropUserId) {
            console.error('ID дропа не указан в параметрах маршрута');
            // Можно добавить редирект или сообщение об ошибке
        }
    },
    methods: {
        closeModal() {
            this.isAddSaleModalOpen = false;
        },
        handleFiltersChange(filters) {
            this.activeFilters = { ...filters };
        },
        handleOrderUpdated() {
            // Если нужно обновить список заказов после изменения
            if (this.$refs.ordersList) {
                this.$refs.ordersList.resetAndLoad();
            }
        }
    }
};
</script>

<style scoped>

</style>